/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import * as React from 'react';

import { createMakeRequest } from '../../../browser/client';
import { getUserData } from '../../reducers/modules/user';
import { ACTIVE_EXPERIMENTS, getExperimentsFlags } from '../../reducers/modules/mainpage';
import { Header } from '../../components/header/header';
import { loadSutochnoPilot } from '../../actions/sutochnoPilot';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../reactContext/applicationContext';
import { getMultipleExperiment } from '../../actions/abUseExperiments';
import { BROWSER_EXPERIMENTS } from '../../constants/experiments';

const styles = require('./app.css');

interface IProps {
  store: IReduxStore;
}

export class App extends React.Component<IProps, {}> {
  static contextType = ApplicationContext;

  context: React.ContextType<typeof ApplicationContext>;

  public componentDidMount() {
    const { store } = this.props;
    const { config } = this.context;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const host = window.__mainpage_api_host__ || window.location.host;
    const isPilotEnabled = config.get<boolean>('sutochnoPilot.enabled');
    const { userAgent } = window.navigator;

    store.dispatch(getUserData(host));
    store.dispatch(getMultipleExperiment(BROWSER_EXPERIMENTS));

    if (isPilotEnabled) {
      store.dispatch(loadSutochnoPilot({ userAgent }));
    }

    getExperimentsFlags(
      store.dispatch,
      createMakeRequest(host),
      ACTIVE_EXPERIMENTS,
      window.location.search.replace('?', ''),
    );
  }

  public render() {
    return (
      <section id={styles['mainpage']}>
        <Header />
        {this.props.children}
      </section>
    );
  }
}
